import React from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Badge, IconButton, Tabs } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';

import { StyledContainer, StyledTitle, StyledTab } from '../../styles';
import { useEsgStakeholderAnalytics } from './StakeholdersAnalytics/hooks';
import { useEsgOrganization } from 'src/common/hooks';

const getSelectedTab = () => {
  const url = window.location.href;
  const regex = /\/(selecting-stakeholders|analytics)\//;
  const match = url.match(regex);
  if (match) {
    return match[1];
  } else {
    return 'selecting-stakeholders';
  }
};

export default function SelectingStakeHolders() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { reportId } = useParams();
  const { id: organizationId } = useEsgOrganization();

  const { dataCount } = useEsgStakeholderAnalytics(
    organizationId,
    reportId as string
  );

  const tab = getSelectedTab();

  const handleTabChange = (_: any, _tab: string) =>
    _tab === 'analytics'
      ? navigate(`../dma/stakeholders/${_tab}/dashboard`)
      : navigate(`../dma/stakeholders/${_tab}`);

  return (
    <StyledContainer>
      <StyledTitle>
        <IconButton onClick={() => navigate('../dma')}>
          <KeyboardArrowLeftIcon fontSize="large" sx={{ color: '#38414f' }} />
        </IconButton>
        {t('esg.dma.selectingStakeholders.title')}
      </StyledTitle>
      <Tabs sx={{ mt: '20px' }} value={tab} onChange={handleTabChange}>
        <StyledTab
          label={t('esg.dma.stakeholderTabs.selectingStakeholders')}
          id="selecting-stakeholders"
          value="selecting-stakeholders"
        />
        <StyledTab
          label={
            dataCount > 0 ? (
              <Badge
                badgeContent={dataCount}
                color="primary"
                sx={{ pr: '10px' }}
              >
                {t('esg.dma.stakeholderTabs.analytics')}
              </Badge>
            ) : (
              t('esg.dma.stakeholderTabs.analytics')
            )
          }
          id="analytics"
          value="analytics"
        />
      </Tabs>
      <Outlet />
    </StyledContainer>
  );
}
